import React from "react"
import PropTypes from "prop-types"

import DiscreteSelectPDFWrapper from "app/static/frontend/components/DiscreteSelectPDFWrapper"

export const AttachmentsPdfSelectViewer = (props) => {
    const formatOptions = () =>
        props.regCommentPdfAttachments.map((option, i) => ({
            label: option.title,
            value: i,
        }))

    const getOptions = () => {
        const options = {}

        Object.keys(props.regCommentPdfAttachments).forEach((key, index) => {
            options[index] = props.regCommentPdfAttachments[index].s3_url
        })

        return options
    }

    const getDefault = () => props.regCommentPdfAttachments.length && 0
    const getUrl = ({ options, selected }) => options[selected]

    return (
        <DiscreteSelectPDFWrapper
            className="pdf-select"
            formatOptions={formatOptions}
            getDefault={getDefault}
            getUrl={getUrl}
            options={getOptions()}
        />
    )
}

AttachmentsPdfSelectViewer.propTypes = {
    regCommentPdfAttachments: PropTypes.arrayOf(PropTypes.object),
}

export default AttachmentsPdfSelectViewer
